<template>
  <div class="r-measurements">
    <!-- sizeTypeId:{{ sizeTypeId }} -->
    <!-- <div class="common-flex menus">
      <div>
        <div class="title">{{ $t("newOrder.tailored") }}</div>
        <Select
          v-model="model"
          :placeholder="$t('newOrder.placeholder')"
          style="width: 428px"
        >
          <Option v-for="item in list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div>
        <div class="title">{{ $t("newOrder.dressStyle") }}</div>
        <Select
          v-model="model"
          :placeholder="$t('newOrder.placeholder')"
          style="width: 428px"
        >
          <Option v-for="item in list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div>
        <div class="title">{{ $t("newOrder.suit") }}</div>
        <Select
          v-model="model"
          :placeholder="$t('newOrder.placeholder')"
          style="width: 428px"
        >
          <Option v-for="item in list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
    </div> -->
    <!-- 选择尺寸类型 -->
    <div class="common-flex common-flex-wrap size-item-fixed" :style="[right?{right:right+'px'}:{}]" v-if="sizeTypeId == 10054">
      <div
        class="fixed-item common-hover"
        :class="item.id == standardChoose.id ? 'fixed-item-check' : ''"
        v-for="(item, index) in standardList"
        :key="index"
        @click="changeStandard(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 选择号型 -->
    <!-- <div
      class="common-flex common-flex-wrap"
      style="margin-top: 20px"
      v-if="sizeTypeId == 10054"
    >
      <div
        class="size-item common-hover"
        :class="item.sizeId == standardChoose.sizeId ? 'size-item-check' : ''"
        v-for="(item, index) in sizeType"
        :key="index"
        @click="changeSizeId(item)"
      >
        {{ item.shape }}
      </div>
    </div> -->
    <!-- 填写尺寸 -->
    <div class="size-box common-flex common-justify-between">
      <!-- 894 -->
      <div>
        <div v-for="(item, index) in clothing" :key="index" class="size-list" :style="sizeTypeId == 10054?{width:'1360px'}:{width:'425px'}">
          <div class="common-flex common-justify-between common-align-center">
            <div class="common-flex common-align-center common-justify-between" :style="sizeTypeId == 10054?{width:'1360px'}:{width:'425px'}">


              <div
                v-if="sizeTypeId == 10052"
                class="
                  common-flex common-justify-between common-align-center
                  
                "
                :class="item.styleList&&item.styleList.length>0?'style-select':''"
              >
                <div class="size-title" style="padding: 8px 0;">{{ item.name }}</div>
                <Select
                v-if="item.styleList&&item.styleList.length>0"
                :transfer="true"
                  v-model="item.chooseStyleId"
                  :placeholder="$t('newOrder.placeholder')"
                  style="width: 200px;flex:1"
                >
                  <Option
                    v-for="citem in item.styleList"
                    :value="citem.id"
                    :key="citem.id"
                    >{{ citem.name }}</Option
                  >
                </Select>
              </div>
              <Button @click="preSubmit" v-if="sizeTypeId === 10052&&categoryMessage.type!==1&&preSubmitShow">Presubmit</Button>
            </div>
          </div>
          <div class="size-title" v-if="sizeTypeId !== 10052">{{ item.name }}</div>
          <div
            class="common-flex common-flex-wrap"
            style="margin-top: 20px"
            v-if="sizeTypeId == 10054"
          >
            <div
              class="size-item common-hover"
              :class="item.chosoeId == citem.id ? 'size-item-check' : ''"
              v-for="(citem, cindex) in item.standardList"
              :key="cindex"
              @click="changeSizeId(item, citem)"
            >
              {{ citem.shape }}
              <!-- {{ item.chosoeId }} -->
            </div>
          </div>
          <div class="list-item" :class="sizeTypeId!==10052&&sizeTypeId!=10053?'common-flex common-flex-wrap':''">
            <!-- common-justify-between -->
            <!--  -->
            <template v-for="(sitem, sindex) in item.sizeList">
              <div
                v-if="!sitem.disabled"
                :style="[
                  (sindex + 1) % 3 == 0
                    ? { marginRight: 0 }
                    : { marginRight: '30px' },
                ]"
                :key="sindex"
              >
                <rIptText
                  :addMove="sizeTypeId == 10054 ? true : false"
                  :unit="unit"
                  :config="sitem"
                  :width="425"
                  :titleWidth="110"
                  :sizeTypeId="sizeTypeId"
                ></rIptText>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 428 -->
      <div class="size-summary" v-if="garmentSize.length > 0">
        <!-- <div class="finished-title">{{ $t("newOrder.finishedTitle") }}</div> -->

        <div
          v-for="(item, index) in garmentSize"
          :key="index"
          style="margin-top: 40px"
        >
          <div class="finished-p-title">
            {{ $t("newOrder.forfinishedTitle") }} {{ item.name }}
          </div>
          <div
            v-for="(citem, cindex) in item.list"
            :key="cindex"
            class="common-flex common-justify-between finished-item"
          >
            <div>{{ citem.name }}：</div>
            <div>{{ citem.size }} {{ unit.heightUnitName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rIptText from "./r-ipt-text-finish";
// import { cmToInch, inchToCom } from "../libs/util";
import { mapActions } from "vuex";
export default {
  components: {
    rIptText,
  },
  data() {
    return {
      standardChoose: {
        property: "", //finished||size  size需要传当前加减值
        id: "",
        sizeId: "",
      },
      model: "",
      list: [
        {
          value: "New York",
          label: "New York",
        },
        {
          value: "London",
          label: "London",
        },
      ],
      sizeType: [
        // {
        //   name: "MTM size",
        // },
        // {
        //   name: "US and UK",
        // },
        // {
        //   name: "MTM size",
        // },
      ],
      size: [
        {
          label: "Height",
          must: true,
          inputValue: "",
          type: "iptText",
          suffixValue: "inch",
          min: 80,
          max: 120,
          addNum: 0.5,
        },
        {
          label: "Height",
          must: true,
          inputValue: "",
          type: "iptText",
          suffixValue: "inch",
          min: 80,
          max: 120,
          addNum: 1,
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "shapeCategoryAction", //尺码类型查标准号
      "measureInfoAction", //具体填写尺码信息
    ]),
    preSubmit(){
      this.$emit('preSubmit')
    },
    // 选择标准号的尺码
    measureInfo(e) {
      this.$emit("measureInfo", e);
      // this.measureInfoAction({
      //   category:this.$route.query.id,
      //   measureType:this.sizeTypeId,
      //   shapeCategory:e
      // }).then(res=>{
      //   console.log('信息',res)
      //   // res.data.map(item=>{
      //   //   this.clothing.map(citem=>{
      //   //     if(item.id == citem.id){
      //   //       citem.sizeList = item.sizeList
      //   //     }
      //   //   })
      //   // })
      // })
    },
    changeStandard(e) {
      this.standardChoose.id = e.id;
      this.standardChoose.property = e.property;
      if (!this.editOnce) {
        this.measureInfo(e.id);
      } else {
        this.$emit("changeEditOnce");
      }
      this.$emit("changeStandard", this.standardChoose);
      // this.shapeCategoryAction({
      //   standardId: e.id,
      // }).then((res) => {
      //   console.log("号型列表", res);
      //   this.sizeType = res.data;
      // });
    },
    changeSizeId(item, citem) {
      item.chosoeId = citem.id;
      // if (this.unit.heightUnit == 10266) {
      //   this.cms(citem.details);
      // } else if (this.unit.heightUnit == 10265) {
      //   //英寸
      //   this.inchs(citem.details);
      // }
      item.sizeList = citem.details;
      // console.log("changeSizeId", citem.details);
      // this.standardChoose.sizeId = e.sizeId;
      // this.$emit("changeSizeId", this.standardChoose);
    },
    // cms(e) {
    //   e.map((sitem) => {
    //     sitem.inputValue = Number(inchToCom(sitem.inputValue).toFixed(2));
    //     sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
    //     sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
    //   });
    // },
    // inchs(e) {
    //   e.map((sitem) => {
    //     sitem.inputValue = Number(cmToInch(sitem.inputValue).toFixed(2));
    //     sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
    //     sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
    //   });
    // },
  },

  watch: {
    clothing: {
      handler(newval, oldval) {
        // console.log("newval", newval);
      },
      deep: true,
      immediate: true,
    },
    // standardChooseParent: {
    //   handler(newval, oldval) {
    //     if( newval.id){
    //       this.standardChoose = newval
    //       console.log('this.standardChoose',this.standardChoose )
    //       this.changeStandard(this.standardChoose)
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    sizeTypeId: {
      handler(newval, oldval) {
        console.log('newval',newval)
        if (this.standardChooseParent.id && newval == 10054) {
          this.standardChoose = this.standardChooseParent;
          // console.log('this.standardChoose',this.standardChoose )
          this.changeStandard(this.standardChoose);
        }
      },
      deep: true,
      immediate: true,
    },
    unit: {
      handler(newval, oldval) {
        // console.log("单位", newval);
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    right:[String,Number],
    clothing: Array,
    sizeList: Array,
    standardList: Array, //尺码类型
    standardChooseParent: [Object, String],
    categoryMessage: [Object, String],
    sizeTypeId: [Number, String], //类型
    unit: [String, Object], //单位
    garmentSize: Array,
    editOnce: Boolean,
    preSubmitShow: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.size-item-fixed{
  position: absolute;
  right: 0;
  top: -66px;
  .fixed-item{
    color: #081938;
    margin-bottom: 10px;
    // width: 120px;
    font-size: 14px;
    text-align: center;
    margin-right: 30px;
  }
  .fixed-item-check{
    color: #0A4DCC;
    position: relative;
    font-weight: 500;
  }
  .fixed-item-check::after{
    position: absolute;
    content: "";
    height: 2px;
    width: 100%;
    left: 0;
    bottom: -4px;
    background-color: #0A4DCC;
  }
}
.r-measurements {
  text-align: left;
  position: relative;
  .size-item {
    height: 26px;
    line-height: 26px;
    border-radius: 4px;
    background: #fff;
    padding: 0 17px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 400;
    text-align: center;
    color: #9ca3af;
    margin-right: 10px;
    background-color: #F8F8F8;
    color: #081938;
    margin-bottom: 10px;
    width: 120px;
  }
  .size-item-check {
    color: #0a4dcc;
    font-weight: 700;
    background: #f8f8f8;
    background-color: #0A4DCC;
    color: #fff;
  }

  .title {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 16px;
    margin-bottom: 12px;
  }
  .menus {
    padding-bottom: 20px;
    // box-shadow: 10px 10px 5px #999;
    > div {
      margin-right: 38px;
    }
  }
  .size-box {
    width: 1360px;
    margin-top: 30px;
    .size-list {
      width: 400px;
      // width: 990px;
      // .finished-measurements {
      //   font-size: 12px;
      //   font-family: Roboto;
      //   font-weight: 700;
      //   text-decoration: underline;
      //   text-align: center;
      //   color: #1e64d2;
      //   line-height: 14px;
      // }

      .size-title {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 700;
        text-align: left;
        color: #000000;
        margin-right: 15px;
      }
      .style-select {
        // width: 290px;
        width: 310px;
        padding-left: 12px;
        border: 1px solid #b4bac3;
        color: rgba(8, 25, 56, 0.7);
        border-radius: 4px;
        margin-bottom: 10px;
        /deep/.ivu-select-selection {
          border: none;
          box-shadow: none;
        }
      }
    }
    .list-item {
      > div {
        margin: 20px 0;
      }
    }

    .size-summary {
      width: 428px;
      padding: 30px 40px;
      background: #f8f8f8;
      .finished-title {
        opacity: 0.7;
        font-size: 16px;
        font-family: Roboto;
        font-weight: 400;
        color: #081938;
        line-height: 19px;
        margin-bottom: -10px;
      }
      .finished-p-title {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 700;
        color: #081938;
        line-height: 16px;
      }
      .finished-item {
        opacity: 0.7;
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        // text-align: left;
        color: #081938;
        line-height: 16px;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-measurements-quick.vue